import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AppNavigation from "./navigation/AppNavigation";
import React from "react";
import { intl } from "@/lib/i18n";
import { CallDialogProvider } from "@/context/CallDialogContext";
import { MessageDialogProvider } from "@/context/MessageDialogContext";
import { HubSpotChatLoader } from "@/components/provider/HubSpotChatLoader";
import { Toaster } from "sonner";

intl();

export default function App() {
  return (
    <CallDialogProvider>
      <MessageDialogProvider>
        <AuthProvider>
          <div className="relative top-0 left-0 w-full h-full m-0 p-0">
            <RouterProvider router={AppNavigation} />
          </div>
        </AuthProvider>
        <HubSpotChatLoader />
        <Toaster />
      </MessageDialogProvider>
    </CallDialogProvider>
  );
}
